import { createContext, useState } from "react";
import type { IUsersContextData, IUsersProviderProps } from "./types";
import { createUsersUtils } from "./utils";
import Loading from "../../components/Shared/Loading";

export const UsersContext = createContext<IUsersContextData | null>(null);

export const UsersProvider = ({ children }: IUsersProviderProps) => {
  const [isLoading, _setIsLoading] = useState(false);

  const contextValue: IUsersContextData = {
    ...createUsersUtils(),
  };

  return (
    <UsersContext.Provider value={contextValue}>
      {isLoading && <Loading />}
      {children}
    </UsersContext.Provider>
  );
};
